import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Agir from '../views/Agir2.vue'
import Etre from '../views/Etre2.vue'
import Interview from '../views/Interview.vue'
import Mentions from '../views/Legals.vue'
import Transition from '../views/Transition.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/agir/:slug?',
    name: 'Agir',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Agir,
  },
  {
    path: '/etre',
    name: 'Etre',
    component: Etre,
  },
  {
    path: '/interview-des-dirigeants',
    name: 'Interview',
    component: Interview,
  },
  {
    path: '/mentions-legales',
    name: 'Mentions',
    component: Mentions,
  },
  {
    path: '/loading',
    name: 'Transition',
    component: Transition,
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  router.app.menuMobile = false;
  next();
})

export default router
